import React from 'react';
import { IntlMessagesProvider } from '@atlaskit/intl-messages-provider';
import { defaultLocale, fetchMessagesForLocale } from './fetch-messages-for-locale';
export var BSCIntlProvider = function BSCIntlProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(IntlMessagesProvider, {
    defaultMessages: defaultLocale,
    loaderFn: fetchMessagesForLocale
  }, children);
};